import { Component, inject, TemplateRef, viewChild } from '@angular/core';

import { DialogHandlerComponent } from '../../shared/dialog-handler/dialog-handler.component';

import { FleetService } from '../../services/fleet.service';
import { ShipService } from '../../services/ship.service';

import { Fleet } from '../../interfaces/fleet';

@Component({
  selector: 'ism-merge-fleet',
  standalone: false,
  templateUrl: './merge-fleet.component.html',
})
export class MergeFleetComponent extends DialogHandlerComponent {
  shipService = inject(ShipService);
  fleetService = inject(FleetService);
  starSystemSelect = viewChild.required<TemplateRef<any>>('starSystemId');

  title: string = 'Merge Fleets';
  baseFleet: Fleet;
  selectedFleets: Set<string> = new Set<string>();
  otherFleets: Fleet[] = [];

  constructor () {
    super();

    this.baseFleet = Object.assign({}, this.data.document as Fleet);
    this.otherFleets = this.data['otherFleets'] as Fleet[];
  };

  toggleFleet (fleetId) {
    if (this.selectedFleets.has(fleetId)) {
      this.selectedFleets.delete(fleetId);
    }
    else {
      this.selectedFleets.add(fleetId);
    }
  };

  override save () {
    let fleets = [];
    this.selectedFleets.forEach(fleetId => {
      fleets.push(fleetId);
    });

    this.dialogRef.close({
      documentName: "Fleet",
      document: this.baseFleet,
      selectedFleets: fleets
    });
  };
};
